/**
 * Safety Equipment Data Constants
 * LSA and Special Equipment options for Step 5
 */

// LSA Equipment options (excluding MOB recovery equipment which has its own section)
export const lsaEquipmentOptions = [
  { 
    value: 'inflatable_lifejackets', 
    label: 'Inflatable Lifejackets', 
    help: 'Requires 2 additional spare lifejackets and inflation system maintenance',
    reference: 'WBC3 14.4.4'
  },
  { 
    value: 'immersion_suits', 
    label: 'Immersion Suits', 
    help: 'Thermal protective survival suits for cold water operations',
    reference: 'WBC3 Section 22.2.6.2'
  },
  { 
    value: 'thermal_protective_aids', 
    label: 'Thermal Protective Aids (TPA)', 
    help: 'Additional thermal protection for liferaft use',
    reference: 'WBC3 14.5.1'
  },
  { 
    value: 'line_throwing_apparatus', 
    label: 'Line Throwing Apparatus', 
    help: 'Rocket line or similar for rescue operations',
    reference: 'WBC3 Table 27.2.3 Section 14.1'
  }
];

// MOB Recovery Equipment options (separated into their own section)
export const mobRecoveryOptions = [
  { 
    value: 'scramble_nets', 
    label: 'Scramble Nets', 
    help: 'For recovery of persons from water',
    reference: 'WBC3 14.7'
  },
  { 
    value: 'jason_cradle', 
    label: "Jason's Cradle", 
    help: 'MOB recovery equipment for safe recovery',
    reference: 'MGN 544'
  },
  { 
    value: 'recovery_basket', 
    label: 'Recovery Basket/Davit', 
    help: 'Personnel recovery system with lifting capability',
    reference: 'WBC3 14.7'
  }
];

// Special equipment options (vessel-specific operational equipment)
export const specialEquipment = [
  { 
    value: 'winch_lifting_gear', 
    label: 'Winch/Lifting Gear', 
    help: 'Requires LOLER inspections and emergency stop familiarisation',
    reference: 'WBC3 8.8 (Lifting appliances)'
  },
  { 
    value: 'gas_detection', 
    label: 'Portable Gas Detection', 
    help: 'For enclosed space entry and gas detection',
    reference: 'WBC3 15.6.4 (Gas detection)'
  },
  { 
    value: 'crane', 
    label: 'Deck Crane', 
    help: 'Lifting equipment requiring training and LOLER inspections',
    reference: 'LOLER 1998'
  },
  { 
    value: 'dynamic_positioning', 
    label: 'Dynamic Positioning System', 
    help: 'DP system requiring operator training and annual trials',
    reference: 'IMO MSC Guidelines'
  },
  { 
    value: 'motion_compensated_gangway', 
    label: 'Motion Compensated Gangway', 
    help: 'CTV gangway system for personnel transfer',
    reference: 'WBC3 Section 22.3'
  },
  { 
    value: 'fender_systems', 
    label: 'Active Fender Systems', 
    help: 'Deployable fender systems for offshore operations',
    reference: 'Operational requirement'
  }
];